import { get, post } from "../services/HttpService";


export class VendorModel {
    static validations = {};

    static checkVendor = (queryData = {}, config = {}) => {
        return post(`emeter/api/v1/check_biller/`, queryData, config).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static getCustomerDetails = (queryData = {}) => {
        const config = { paramsSerializer: { indexes: null } };
        return post(`emeter/api/v1/fetch_bill/`, queryData, config).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static payBill = (queryData = {}) => {
        const config = { paramsSerializer: { indexes: null } };
        return post(`emeter/api/v1/pay_bill/`, queryData, config).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };
}